var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.1,
    d: "M11.373 12.092h0l-.216-.458 1.146-1.146c.177-.177.177-.465 0-.642l-1.74-1.74c-.194-.194-.516-.172-.685.044h0c-1.581 2.025-.963 5.44 1.474 7.878 2.438 2.438 5.854 3.055 7.878 1.474.216-.17.238-.49.044-.685l-1.74-1.74c-.177-.177-.464-.177-.642 0h0l-1.147 1.148c-1.924-.78-3.485-2.255-4.371-4.133z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.1,
    d: "M12.614 3.026h0c3.233-.42 6.408.64 8.71 2.9l.035-.035-.035.036c2.301 2.26 3.415 5.412 3.055 8.646-.52 4.671-4.296 8.517-8.977 9.14-1.984.265-3.997-.048-5.82-.903-.234-.11-.503-.116-.743-.019h0l-3.243 1.325.585-3.33c.047-.266-.026-.54-.2-.75h0c-1.881-2.262-2.703-5.135-2.314-8.089.605-4.578 4.368-8.33 8.947-8.921zM4.747 26.46l4.425-1.809c2.043.88 4.272 1.187 6.475.894 5.51-.735 9.956-5.263 10.568-10.768.423-3.8-.887-7.507-3.596-10.168-2.709-2.662-6.442-3.907-10.24-3.417C6.98 1.89 2.547 6.31 1.835 11.706c-.439 3.324.43 6.565 2.453 9.173l-.801 4.566s0 0 0 0l1.259 1.015z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWhatsapp);
export default __webpack_public_path__ + "static/media/account-whatsapp.7e4c335f82829b5059f295431ed0b47b.svg";
export { ForwardRef as ReactComponent };